
import { useState } from "react";
import { useCamera } from '@ionic/react-hooks/camera';
// import { useFilesystem  } from '@ionic/react-hooks/filesystem';
// import { useStorage } from '@ionic/react-hooks/storage';
import { CameraResultType, CameraSource } from "@capacitor/core";
import { urltoFile} from '../services/utils';
import { IPhotoItem, IPhotoFile } from '../domain/PhotoItem';
import { uploadPictures } from '../services/asyncDataService';

//const PHOTO_STORAGE = "photos";

export function usePhotoGallery() {
    const { getPhoto } = useCamera();
    const [photos, setPhotos] = useState<Photo[]>([]);
   
    //const { get } = useStorage();
    //const { readFile } = useFilesystem();
    //writeFile
    //useEffect(() => {
        // const loadSaved = async () => {
        //   const photosString = await get('photos');
        //   const photos = (photosString ? JSON.parse(photosString) : []) as Photo[];
        //   // If running on the web...
        //     if (!isPlatform('hybrid')) {
        //     for (let photo of photos) {
        //         const file = await readFile({
        //             path: photo.filepath,
        //             directory: FilesystemDirectory.Data
        //         });
        //         photo.webviewPath = `data:image/jpeg;base64,${file.data}`;
        //     }
        //     setPhotos(photos);
        //     };
        // }   
        //loadSaved();
    //}, [get, readFile]);

    const savePicture = async (photo: any, fileName: string, token:string, activityId:number, clientId: number) => {
       
        let convertedFile: File = await urltoFile(photo.webPath as string, fileName, photo.format);

        let pictureModels: IPhotoItem[] = [];
        pictureModels.push({PhotoID: null, ClientID : clientId, FileName: ''} as IPhotoItem);
        let pictureStreams : File[] = [];
        pictureStreams.push(convertedFile);

        //send to API
        let response = await uploadPictures(token, clientId, pictureModels, pictureStreams);
        if (response && (response as any).data && (response as any).data.length > 0 ) {
            let apiResponse: IPhotoFile = (response as any).data[0];
                return {
                  photoId: 0,
                  filepath: apiResponse.FileName,
                  webviewPath: apiResponse.UrlFileName
                };
        }
    };

    const takePhoto = async (token:string, activityId:number, clientId: number) => {
        const cameraPhoto = await getPhoto({
            resultType: CameraResultType.Uri,
            source: CameraSource.Prompt,
            quality: 100,
        });
        if (cameraPhoto.format === "tiff") {
            return;
        }
        const fileName = new Date().getTime() + '.jpeg';
        const savedFileImage = await savePicture(cameraPhoto, fileName, token, activityId, clientId) as Photo;
        if (savedFileImage) {
            const newPhotos:Photo[] = [savedFileImage, ...photos];
            setPhotos(newPhotos);
        }
    };

    const deletePhoto =  (_photo: Photo) => {
        let remainingPhotos = photos.filter((x:any) => x.filepath !== _photo.filepath);
        setPhotos(remainingPhotos);
    };
  
    return {
        photos,
        takePhoto,
        deletePhoto
    };
};

export interface Photo {
    photoId: 0;
    filepath: string;
    webviewPath: string;
};